import Vue from "vue";
import usercenter from "./usercenter";
import integral from "./integral";
import afterClassReport from "./student/afterClassReport";

const view = Vue.extend({ render: h => h("router-view") });

// app内课时明细
const lessonDetail = () => import("@/views/student/lessonDetail/index.vue");
// 通用请假明细
const leaveDetail = () => import("@/views/student/leaveDetail/index.vue");
// 通用我的课程
const myCourses = () => import("@/views/student/myCourses/index.vue");
// app内课时评价
const lessonEvaluation = () =>
  import("@/views/student/lessonEvaluation/index.vue");
// app内发票订单
const invoiceOrder = () =>
  import(
    /* webpackChunkName: "student-invoice" */ "@/views/student/invoiceOrder/index.vue"
  );
// app内选择订单开票
const invoiceSelect = () =>
  import(
    /* webpackChunkName: "student-invoice" */ "@/views/student/invoiceSelect/index.vue"
  );
// app内开票历史
const invoiceHistory = () =>
  import(
    /* webpackChunkName: "student-invoice" */ "@/views/student/invoiceHistory/index.vue"
  );
// app内开票详情
const invoiceDetail = () =>
  import(
    /* webpackChunkName: "student-invoice" */ "@/views/student/invoiceDetail/index.vue"
  );
// app内填写开票信息
const invoiceIssueElectronic = () =>
  import(
    /* webpackChunkName: "student-invoice" */ "@/views/student/invoiceIssueElectronic/index.vue"
  );
// app内查看开票详情时跳转的电子普通发票页面
const invoiceOrdinaryElectronic = () =>
  import(
    /* webpackChunkName: "student-invoice" */ "@/views/student/invoiceOrdinaryElectronic/index.vue"
  );
// 公众号支付完成带赠品地址的情况(此页由于后端原因，没有用到)
const payCompleted = () =>
  import(
    /* webpackChunkName: "pay-completed" */ "@/views/student/payCompleted/index.vue"
  );
// 公众号支付完成填写收获地址页面
const harvestAddress = () =>
  import(
    /* webpackChunkName: "harvest-address" */ "@/views/student/harvestAddress/index.vue"
  );
// 公众号个人中心(公众号)
const personalCenter = () =>
  import(
    /* webpackChunkName: "personal-center" */ "@/views/student/personalCenter/index.vue"
  );
// 公众号我的订单列表
const wxMyOrder = () =>
  import(
    /* webpackChunkName: "wx-my-order" */ "@/views/student/wxMyOrder/index.vue"
  );
// 公众号订单协议
const agreement = () =>
  import(
    /* webpackChunkName: "student-agreement" */ "@/components/publicServiceAgreement/index.vue"
  );
// // 增加订单课时
// const AddOrderHours = () =>
//   import(
//     /* webpackChunkName: "student-AddOrderHours" */ "@/views/student/AddOrderHours/index.vue"
//   );

// 通用-增加订单课时
const orderDetailOk = () =>
  import(
    /* webpackChunkName: "order-detail-ok" */ "@/views/student/wxMyOrder/orderDetailOk.vue"
  );
// 通用-退费单详情
const refundDetail = () =>
  import(
    /* webpackChunkName: "refund-detail" */ "@/views/student/refundDetail/index.vue"
  );
// app内课时评价
const stageReport = () => import("@/views/student/stageReport/index.vue");
// app内美术宝公告
const appNotice = () =>
  import(
    /* webpackChunkName: "app-notice" */ "@/views/student/appNotice/index.vue"
  );
// app内美术宝公告详情
const appNoticeDetails = () =>
  import(
    /* webpackChunkName: "app-notice-details" */ "@/views/student/appNoticeDetail/index.vue"
  );
// app学习报告列表
const appStudyReport = () =>
  import(
    /* webpackChunkName: "app-study-report" */ "@/views/student/studyReport/index.vue"
  );

// 作品集列表(app与公众号通用)
const workList = () =>
  import(
    /* webpackChunkName: "work-list" */ "@/views/student/workList/index.vue"
  );
// app满意度调查报告
const appExamineReport = () =>
  import(
    /* webpackChunkName: "examineReport-app" */ "@/views/student/examineReport/index.vue"
  );
// app与公众号通用我的包裹页面
const packageList = () =>
  import(
    /* webpackChunkName: "student-common" */ "@/views/student/packageList/index.vue"
  );
// app与公众号通用物流详情页面
const detailLogistics = () =>
  import(
    /* webpackChunkName: "student-common" */ "@/views/student/logisticsDetail/index.vue"
  );

// app与公众号通用物流详情页面(新)
const orderDetail = () =>
  import(
    /* webpackChunkName: "student-common" */ "@/views/student/orderDetail/index.vue"
  );

// 美术小知识(app)
const artKnowledge = () =>
  import(
    /* webpackChunkName: "art-knowledge" */ "@/views/student/artKnowledge/index.vue"
  );

// 试听课测评报告(app)
const trialLessonEvaluationReport = () =>
  import(
    /* webpackChunkName: "trial-lesson-evaluation-report" */ "@/views/student/trialLessonEvaluationReport/index.vue"
  );

// 试听课测评报告(新版)
const newTrialLessonEvaluationReport = () =>
  import(
    /* webpackChunkName: "new-trial-lesson-evaluation-report" */ "@/views/student/trialLessonEvaluationReport/new.vue"
  );

// 通用-分享有礼
const sharePosterCourtesy = () =>
  import(
    /* webpackChunkName: "sharePosterCourtesy" */ "@/views/student/sharePosterCourtesy/index.vue"
  );
// 通用-分享有礼 -》 分享海报的赠课的标准页面
const saveImgPage = () =>
  import(
    /* webpackChunkName: "sharePosterCourtesy" */ "@/views/student/sharePosterCourtesy/saveImgPage.vue"
  );
// 通用-分享有礼总入口
const sharePosterCourtesyEntry = () =>
  import(
    /* webpackChunkName: "sharePosterCourtesy" */ "@/views/student/sharePosterCourtesyEntry/index.vue"
  );
// 通用-分享有礼- > Swiper
const sharePosterSwiper = () =>
  import(
    /* webpackChunkName: "sharePosterCourtesy" */ "@/views/student/sharePosterSwiper/index.vue"
  );
// /Users/liangyanqiao/MacDev/MuJin/gitab/msb-1v1-h5/src/
// 通用 学习报告的登录页
// 公众号-自主约课列表
const scheduleClassesList = () =>
  import(
    /* webpackChunkName: "schedule-classes-list" */ "@/views/student/scheduleClassesList/index.vue"
  );
// 公众号-自主约课页面
const scheduleClasses = () =>
  import(
    /* webpackChunkName: "schedule-classes" */ "@/views/student/scheduleClasses/index.vue"
  );
// 通用 学习报告的登录页
const stageReportLogin = () =>
  import(
    /* webpackChunkName: "stageReportLogin" */ "@/components/stageReportLogin/index.vue"
  );
// app-课前预习
const previewClass = () =>
  import(
    /* webpackChunkName: "preview-class" */ "@/views/student/previewClass/index.vue"
  );
// 预习报告
const previewReport = () =>
  import(
    /* webpackChunkName: "preview-report" */ "@/views/student/previewClass/report.vue"
  );
// 通用-取消约课
const cancelAppointment = () =>
  import(
    /* webpackChunkName: "cancel-appointment" */ "@/views/student/cancelAppointment/index.vue"
  );
// 通用- 我的地址
const shippingAddress = () =>
  import(
    /* webpackChunkName: "shippingAdress" */ "@/views/student/shippingAddress/index.vue"
  );
// 通用- 我的地址-编辑地址
const editAddress = () =>
  import(
    /* webpackChunkName: "shippingAdress" */ "@/views/student/shippingAddress/editAddress.vue"
  );

// 通用- 偏好设置
const preferences = () =>
  import(
    /* webpackChunkName: "Preferences" */ "@/views/student/preferences/index.vue"
  );

// 通用 优惠卷
const userCoupon = () =>
  import(
    /* webpackChunkName: "userCoupon" */ "@/views/student/userCoupon/index.vue"
  );
// 邀请明细
const inviteDetail = () =>
  import(
    /* webpackChunkName: "inviteDetail" */ "@/views/student/inviteDetail/index.vue"
  );
// 邀请明细
const inviteDataView = () =>
  import(
    /* webpackChunkName: "inviteDetail" */ "@/views/student/inviteDataView/index.vue"
  );

const shareCreatePoster = () =>
  import(
    /* webpackChunkName: "shareCreatePoster" */ "@/views/student/shareCreatePoster/index.vue"
  );

//商城页面
const goldMall = () =>
  import(
    /* webpackChunkName: "goldMall" */ "@/views/student/goldMall/index.vue"
  );
// 预约课时计划-预约课程页面
const reservationLessonPlan = () =>
  import(
    /* webpackChunkName: "reservationLessonPlan" */ "@/views/student/reservationLessonPlan/index.vue"
  );
// 预约课时计划-选择固定课时间
const chooseFixedLesson = () =>
  import(
    /* webpackChunkName: "reservationLessonPlan" */ "@/views/student/reservationLessonPlan/chooseFixedLesson.vue"
  );
// 预约课时计划-预约临时课
const reserveTemporaryLesson = () =>
  import(
    /* webpackChunkName: "reserveTemporaryLesson" */ "@/views/student/reservationLessonPlan/reserveTemporaryLesson.vue"
  );
// 预约课时计划-取消约课
const appointMentCancel = () =>
  import(
    /* webpackChunkName: "appointMentCancel" */ "@/views/student/reservationLessonPlan/appointMentCancel.vue"
  );
// 预约课时计划-约课成功
const appointMentComplete = () =>
  import(
    /* webpackChunkName: "appointMentComplete" */ "@/views/student/reservationLessonPlan/appointMentComplete.vue"
  );
//专项技术提升课宣传页面
const specialPromotion = () =>
  import(
    /* webpackChunkName: "specialPromotion" */ "@/views/student/specialPromotion/index.vue"
  );
// 订单确认页
const payOrder = () =>
  import(
    /* webpackChunkName: "payOrder" */ "@/views/student/payOrder/index.vue"
  );
// 小班体验课支付
const experienceSmallClassPay = () =>
  import(
    /* webpackChunkName: "experienceSmallClassPay" */ "@/views/student/payOrder/experienceSmallClassPay.vue"
  );

//美术宝小知识
const smallKnowledge = () =>
  import(
    /* webpackChunkName: "smallKnowledge" */ "@/views/student/smallKnowledge/index.vue"
  );

const smallKnowLedgeVideo = () =>
  import(
    /* webpackChunkName: "smallKnowLedgeVideo" */ "@/views/student/smallKnowledge/video/index.vue"
  );

const testApp = () =>
  import(/* webpackChunkName: "testApp" */ "@/views/student/testApp/index.vue");
// 通用 2.5.1课程评价
const courseEvaluation = () =>
  import(
    /* webpackChunkName: "courseEvaluation" */ "@/views/student/courseEvaluation/index.vue"
  );
// 通用 2.5.1查看课程已评价内容
const courseEvaluationResult = () =>
  import(
    /* webpackChunkName: "courseEvaluation" */ "@/views/student/courseEvaluation/result.vue"
  );

// 通用 2.5.1卡牌活动
const cardsGame = () =>
  import(
    /* webpackChunkName: "cardsGame" */ "@/views/student/cardGame/index.vue"
  );
// app 考级报名页
const examSignUp = () =>
  import(
    /* webpackChunkName: "exam-sign-up" */ "@/views/student/exam/examSignUp.vue"
  );
// app 考级报名页1
const examSignUp1 = () =>
  import(
    /* webpackChunkName: "exam-sign-up1" */ "@/views/student/exam/examSignUp1.vue"
  );
// app 考级报名页1
const examSignUp2 = () =>
  import(
    /* webpackChunkName: "exam-sign-up2" */ "@/views/student/exam/examSignUp2.vue"
  );
// app 图片上传裁剪
const examUpload = () =>
  import(
    /* webpackChunkName: "exam-upload" */ "@/views/student/exam/examUpload.vue"
  );
// app 我的考级
const myExam = () =>
  import(/* webpackChunkName: "my-exam" */ "@/views/student/exam/myExam.vue");
// app 考级详情
const examDetail = () =>
  import(
    /* webpackChunkName: "exam-detail" */ "@/views/student/exam/examDetail.vue"
  );
// 关注老师
const focusTeacher = () =>
  import(
    /* webpackChunkName: "focusOrShieldingTeacher" */ "@/views/student/focusOrShieldingTeacher/focusTeacher.vue"
  );
// 屏蔽老师
const shieldingTeacher = () =>
  import(
    /* webpackChunkName: "focusOrShieldingTeacher" */ "@/views/student/focusOrShieldingTeacher/shieldingTeacher.vue"
  );
// 账号注销提示
const accountCancel = () =>
  import(
    /* webpackChunkName: "accountCancel" */ "@/views/student/accountCancel/index.vue"
  );
// 美育
const beautifulEducation = () =>
  import(
    /* webpackChunkName: "beautifulEducation" */ "@/views/student/beautifulEducation/index.vue"
  );

// 学前期望
const classExpect = () =>
  import(
    /* webpackChunkName: "classExpect" */ "@/views/student/classExpect/index.vue"
  );
// 低性能模式说明
const performanceModeExplain = () =>
  import(
    /* webpackChunkName: "performanceModeExplain" */ "@/views/student/performanceModeExplain/index.vue"
  );
// 小班课详情
const smallClassDetail = () =>
  import(
    /* webpackChunkName: "smallClassDetail" */ "@/views/student/detail/index.vue"
  );
// 预约单节课选老师-选择约课时间
const chooseSingleLesson = () =>
  import(
    /* webpackChunkName: "reservationLessonPlan" */ "@/views/student/reservationLessonPlan/chooseSingleLesson.vue"
  );
// 赛事活动
const matchActivity = () =>
  import(
    /* webpackChunkName: "matchActivity" */ "@/views/student/matchActivity/index.vue"
  );
// 赛事活动
const matchActivityApply = () =>
  import(
    /* webpackChunkName: "matchActivityApply" */ "@/views/student/matchActivity/apply.vue"
  );
// 赛事活动-获取奖品
const matchReward = () =>
  import(
    /* webpackChunkName: "matchReward" */ "@/views/student/matchReward/index.vue"
  );
// 赠课上传截图
const freeLessons = () =>
  import(
    /* webpackChunkName: "freeLessons" */ "@/views/student/freeLessons/index.vue"
  );
// 毕加索续费-获取奖品
const picassoReward = () =>
  import(
    /* webpackChunkName: "picassoReward" */ "@/views/student/picassoReward/index.vue"
  );
// 儿童隐私协议
const childrenPrivacy = () =>
  import(
    /* webpackChunkName: "childrenPrivacy" */ "@/views/student/protocol/childrenPrivacy.vue"
  );
// 用户隐私协议
const privacy = () =>
  import(
    /* webpackChunkName: "privacy" */ "@/views/student/protocol/privacy.vue"
  );
// app弹窗隐私协议
const modalPrivacy = () =>
  import(
    /* webpackChunkName: "modalPrivacy" */ "@/views/student/protocol/modalPrivacy.vue"
  );
// app弹窗隐私协议更新
const modalUpdate = () =>
  import(
    /* webpackChunkName: "modalUpdate" */ "@/views/student/protocol/modalUpdate.vue"
  );
// 推荐优秀老师代课
const excellentTeacher = () =>
  import(
    /* webpackChunkName: "excellent-teacher" */ "@/views/student/leave/excellentTeacher.vue"
  );
// 企业资质
const qualification = () =>
  import(
    /* webpackChunkName: "qualification" */ "@/views/student/qualification/index.vue"
  );
// 补课列表页面
const makeUpLessons = () =>
  import(
    /* webpackChunkName: "makeUpLessons" */ "@/views/student/makeUpLessons/index.vue"
  );
// 课程取消成功补课页面
const makeUpLessonsCancel = () =>
  import(
    /* webpackChunkName: "makeUpLessonsCancel" */ "@/views/student/makeUpLessons/cancel.vue"
  );
// 小班课自动进班链接失效
const linkInvalid = () =>
  import(
    /* webpackChunkName: "linkInvalid" */ "@/views/student/autoIntoClass/linkInvalid.vue"
  );
// 小班课自动进班成功页面
const intoClassSuccess = () =>
  import(
    /* webpackChunkName: "intoClassSuccess" */ "@/views/student/autoIntoClass/intoClassSuccess.vue"
  );

// 小班课 家长点击链接选择进班页面
const parentChooseClass = () =>
  import(
    /* webpackChunkName: "parentChooseClass" */ "@/views/student/autoIntoClass/linkChooseClass.vue"
  );
// 画科分类
const paintingCategory = () =>
  import(
    /* webpackChunkName: "paintingCategory" */ "@/views/student/paintingCategory/index.vue"
  );
// 上课须知
const paintingCategoryClass = () =>
  import(
    /* webpackChunkName: "paintingCategoryClass" */ "@/views/student/paintingCategory/class.vue"
  );
//  强化套餐课消说明
const packageDesc = () =>
  import(
    /* webpackChunkName: "packageDesc" */ "@/views/student/makeUpLessons/introduce.vue"
  );

// 美育
const beautifulEducationRevision = () =>
  import(
    /* webpackChunkName: "beautifulEducationRevision" */ "@/views/student/beautifulEducation/beautifulEducationRevision.vue"
  );
//  联系课程顾问
const courseConsult = () =>
  import(
    /* webpackChunkName: "courseConsult" */ "@/views/student/courseConsult/index.vue"
  );

//  美育系统课介绍
const aiClassSystem = () =>
  import(
    /* webpackChunkName: "aiClassSystem" */ "@/views/student/aiClass/index.vue"
  );
//  美育课程详情
const aiClassDetail = () =>
  import(
    /* webpackChunkName: "aiClassDetail" */ "@/views/student/aiClass/detail.vue"
  );
//  美育课程规则
const aiClassRules = () =>
  import(
    /* webpackChunkName: "aiClassRules" */ "@/views/student/aiClass/rules.vue"
  );
//  美育课程体系介绍
const aiClassIntroduce = () =>
  import(
    /* webpackChunkName: "aiClassIntroduce" */ "@/views/student/aiClass/introduce.vue"
  );
//  美育课单个阶段介绍
const aiClassSingle = () =>
  import(
    /* webpackChunkName: "aiClassSingle" */ "@/views/student/aiClass/single.vue"
  );
//  美育课单个阶段介绍
const aiClassTeach = () =>
  import(
    /* webpackChunkName: "aiClassTeach" */ "@/views/student/aiClass/teach.vue"
  );
//  APP隐私协议
const appPrivateAgree = () =>
  import(
    /* webpackChunkName: "appPrivateAgree" */ "@/views/student/appAgreement/private/index.vue"
  );
//  APP用户协议
const appUserAgree = () =>
  import(
    /* webpackChunkName: "appUserAgree" */ "@/views/student/appAgreement/user/index.vue"
  );
//  APP用户注册协议
const appUserRegisterAgree = () =>
  import(
    /* webpackChunkName: "appUserRegisterAgree" */ "@/views/student/appAgreement/register/index.vue"
  );
//  APP用户注册协议
const appTouristModel = () =>
  import(
    /* webpackChunkName: "appTouristModel" */ "@/views/student/appAgreement/tourist/index.vue"
  );
//赛事中心
const gameCenter = () =>
  import(
    /* webpackChunkName: "gameCenter" */ "@/views/student/gameCenter/index.vue"
  );
//赛事中心-我的报名
const myApply = () =>
  import(
    /* webpackChunkName: "myApply" */ "@/views/student/gameCenter/myApply.vue"
  );
//  合作方信息目录列表
const appSdkList = () =>
  import(
    /* webpackChunkName: "appSdkList" */ "@/views/student/appAgreement/sdkList/index.vue"
  );
//  合作方信息目录列表
const appPersonList = () =>
  import(
    /* webpackChunkName: "appPersonList" */ "@/views/student/appAgreement/personList/index.vue"
  );
//  声明协议
const appVoice = () =>
  import(
    /* webpackChunkName: "appVoice" */ "@/views/student/appAgreement/voice/index.vue"
  );
//  海外版本隐私政策（包含欧美两个版本）
const appOverPrivate = () =>
  import(
    /* webpackChunkName: "appOverPrivate" */ "@/views/student/appAgreement/oversea/private.vue"
  );
//  海外版本用户协议（包含欧美两个版本）
const appOverUser = () =>
  import(
    /* webpackChunkName: "appOverUser" */ "@/views/student/appAgreement/oversea/user.vue"
  );
//  签约跳转
const signPrepare = () =>
  import(
    /* webpackChunkName: "signPrepare" */ "@/views/student/onLineSign/prepare/index.vue"
  );
//  签约成功(电子签)
const signComplete = () =>
  import(
    /* webpackChunkName: "signComplete" */ "@/views/student/onLineSign/complete/index.vue"
  );
// 中轴线入口页
const matchActivityNewEnter = () =>
  import(
    /* webpackChunkName: "axleWireActivity" */ "@/views/student/axleWireActivity/index.vue"
  );
// 中轴线报名页
const axleWireSignUp = () =>
  import(
    /* webpackChunkName: "axleWireSignUp" */ "@/views/student/axleWireActivity/signUp.vue"
  );
// 中轴线成功页
const axleWireSuccess = () =>
  import(
    /* webpackChunkName: "axleWireSuccess" */ "@/views/student/axleWireActivity/success.vue"
  );
// 中轴线协议页
const axleWireAgree = () =>
  import(
    /* webpackChunkName: "axleWireAgree" */ "@/views/student/axleWireActivity/agreement.vue"
  );
// 中轴线获奖页
const axleWireAwards = () =>
  import(
    /* webpackChunkName: "axleWireAwards" */ "@/views/student/axleWireActivity/awards.vue"
  );
// 赛事活动协议页
const matchActivityAgree = () =>
  import(
    /* webpackChunkName: "matchActivityAgree" */ "@/views/student/matchActivity/agree.vue"
  );
// 个性化约课
const individuationClass = () =>
  import(
    /* webpackChunkName: "reservationLessonPlan-individuation" */ "@/views/student/reservationLessonPlan/individuation.vue"
  );
// 预约临时课-新增搜索页
const searchTeacherForReserve = () =>
  import(
    /* webpackChunkName: "reservationLessonPlan-searchTeacherForReserve" */ "@/views/student/reservationLessonPlan/searchTeacherForReserve.vue"
  );
// 休学明细
const suspendDetail = () =>
  import(
    /* webpackChunkName: "suspendDetail" */ "@/views/student/suspendDetail/index.vue"
  );
// 新增强化课时包 空合同
const emptyIntensifyClassAgreement = () =>
  import(
    /* webpackChunkName: "publicServiceAgreement-extraAgreement" */ "@/components/publicServiceAgreement/extraAgreement/agreement1.vue"
  );

// 音乐宝订单确认页
const yybPayOrder = () =>
  import(
    /* webpackChunkName: "yybPayOrder" */ "@/views/student/yyb/payOrder/index.vue"
  );
//  联系课程顾问
const congratulations2024 = () =>
  import(
    /* webpackChunkName: "congratulations2024" */ "@/views/student/congratulations2024/index.vue"
  );
// 绘画课程
const paintingCourseSubscribe = () =>
  import(
    /* webpackChunkName: "paintingCourseSubscribe" */ "@/views/student/paintingCourse/subscribe.vue"
  );
export default {
  path: "/student",
  component: view,
  children: [
    usercenter,
    integral,
    ...afterClassReport,
    {
      path: "agreement",
      component: agreement
    },
    {
      path: "lessonDetail",
      name: "studentLessonDetail",
      component: lessonDetail
    },
    {
      name: "leaveDetail",
      path: "leaveDetail",
      component: leaveDetail
    },
    {
      name: "myCourses",
      path: "myCourses",
      component: myCourses,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "lessonEvaluation",
      component: lessonEvaluation
    },
    {
      path: "invoiceOrder",
      component: invoiceOrder
    },
    {
      path: "invoiceSelect",
      component: invoiceSelect
    },
    {
      path: "invoiceHistory",
      component: invoiceHistory
    },
    {
      path: "invoiceDetail",
      component: invoiceDetail
    },
    {
      path: "invoiceIssueElectronic",
      component: invoiceIssueElectronic
    },
    {
      path: "invoiceOrdinaryElectronic",
      component: invoiceOrdinaryElectronic
    },
    {
      path: "payCompleted",
      component: payCompleted
    },
    {
      path: "harvestAddress",
      name: "harvestAddress",
      component: harvestAddress
    },
    {
      path: "personalCenter",
      name: "studentPersonalCenter",
      component: personalCenter
    },
    {
      path: "wxMyOrder",
      name: "studentWxMyOrder",
      component: wxMyOrder
    },
    {
      path: "orderDetailOk",
      component: orderDetailOk
    },
    {
      path: "refundDetail",
      component: refundDetail
    },
    {
      path: "stageReport",
      component: stageReport,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "appNotice",
      component: appNotice
    },
    {
      name: "appNoticeDetails",
      path: "appNoticeDetails",
      component: appNoticeDetails
    },
    {
      name: "examineReport",
      path: "examineReport",
      component: appExamineReport
    },
    {
      name: "appStudyReport",
      path: "studyReport",
      component: appStudyReport
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      name: "packageList",
      path: "packageList",
      component: packageList
    },
    {
      name: "detailLogistics",
      path: "detailLogistics",
      component: detailLogistics
    },
    {
      name: "orderDetail",
      path: "orderDetail",
      component: orderDetail
    },
    {
      name: "workList",
      path: "workList",
      component: workList
    },
    {
      name: "sharePosterCourtesy",
      path: "sharePosterCourtesy",
      component: sharePosterCourtesy
    },
    {
      name: "saveImgPage",
      path: "saveImgPage",
      component: saveImgPage
    },
    {
      name: "sharePosterCourtesyEntry",
      path: "sharePosterCourtesyEntry",
      component: sharePosterCourtesyEntry
    },
    {
      name: "sharePosterSwiper",
      path: "sharePosterSwiper",
      component: sharePosterSwiper,
      meta: {
        keepAlive: false
      }
    },
    {
      name: "artKnowledge",
      path: "artKnowledge",
      component: artKnowledge
    },
    {
      name: "trialLessonEvaluationReport",
      path: "trialLessonEvaluationReport",
      component: trialLessonEvaluationReport
    },
    {
      name: "newTrialLessonEvaluationReport",
      path: "newTrialLessonEvaluationReport",
      component: newTrialLessonEvaluationReport
    },
    {
      name: "scheduleClassesList",
      path: "scheduleClassesList",
      component: scheduleClassesList
    },
    {
      name: "scheduleClasses",
      path: "scheduleClasses",
      component: scheduleClasses
    },
    {
      name: "stageReportLogin",
      path: "stageReportLogin",
      component: stageReportLogin
    },
    {
      path: "previewClass",
      component: previewClass
    },
    {
      path: "previewReport",
      component: previewReport
    },
    {
      name: "cancelAppointment",
      path: "cancelAppointment",
      component: cancelAppointment
    },
    {
      name: "shippingAddress",
      path: "shippingAddress",
      component: shippingAddress
    },
    {
      name: "editAddress",
      path: "editAddress",
      component: editAddress
    },
    {
      name: "preferences",
      path: "preferences",
      component: preferences
    },
    {
      name: "userCoupon",
      path: "userCoupon",
      component: userCoupon
    },
    {
      path: "inviteDataView",
      name: "studentInviteDataView",
      component: inviteDataView
    },
    {
      path: "inviteDetail",
      name: "studentInviteDetail",
      component: inviteDetail
    },
    {
      name: "shareCreatePoster",
      path: "shareCreatePoster",
      component: shareCreatePoster
    },
    {
      name: "goldMall",
      path: "goldMall",
      component: goldMall
    },
    {
      name: "specialPromotion",
      path: "specialPromotion",
      component: specialPromotion
    },
    {
      name: "smallKnowledge",
      path: "smallKnowledge",
      component: smallKnowledge
    },
    {
      name: "smallKnowLedgeVideo",
      path: "smallKnowLedgeVideo",
      component: smallKnowLedgeVideo
    },
    {
      name: "payOrder",
      path: "payOrder",
      component: payOrder
    },
    {
      name: "experienceSmallClassPay",
      path: "experienceSmallClassPay",
      component: experienceSmallClassPay
    },
    {
      name: "linkInvalid",
      path: "linkInvalid",
      component: linkInvalid
    },
    {
      name: "intoClassSuccess",
      path: "intoClassSuccess",
      component: intoClassSuccess
    },
    {
      name: "parentChooseClass",
      path: "parentChooseClass",
      component: parentChooseClass
    },
    {
      name: "testApp",
      path: "testApp",
      component: testApp
    },
    {
      name: "reservationLessonPlan",
      path: "reservationLessonPlan",
      component: reservationLessonPlan
    },
    {
      name: "chooseFixedLesson",
      path: "chooseFixedLesson",
      component: chooseFixedLesson
    },
    {
      name: "reserveTemporaryLesson",
      path: "reserveTemporaryLesson",
      component: reserveTemporaryLesson,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "appointMentCancel",
      path: "appointMentCancel",
      component: appointMentCancel
    },
    {
      name: "appointMentComplete",
      path: "appointMentComplete",
      component: appointMentComplete
    },
    {
      name: "courseEvaluation",
      path: "courseEvaluation",
      component: courseEvaluation
    },
    {
      name: "courseEvaluationResult",
      path: "courseEvaluationResult",
      component: courseEvaluationResult
    },
    {
      name: "cardsGame",
      path: "cardsGame",
      component: cardsGame
    },
    {
      name: "examSignUp",
      path: "examSignUp",
      component: examSignUp
    },
    {
      name: "examSignUp1",
      path: "examSignUp1",
      component: examSignUp1,
      meta: {
        keepAlive: true
      }
    },
    {
      name: "examSignUp2",
      path: "examSignUp2",
      component: examSignUp2
    },
    {
      name: "examUpload",
      path: "examUpload",
      component: examUpload
    },
    {
      name: "myExam",
      path: "myExam",
      component: myExam
    },
    {
      name: "examDetail",
      path: "examDetail",
      component: examDetail
    },
    {
      name: "focusTeacher",
      path: "focusTeacher",
      component: focusTeacher
    },
    {
      name: "shieldingTeacher",
      path: "shieldingTeacher",
      component: shieldingTeacher
    },
    {
      name: "accountCancel",
      path: "accountCancel",
      component: accountCancel
    },
    {
      name: "beautifulEducation",
      path: "beautifulEducation",
      component: beautifulEducation
    },
    {
      name: "classExpect",
      path: "classExpect",
      component: classExpect
    },
    {
      name: "performanceModeExplain",
      path: "performanceModeExplain",
      component: performanceModeExplain
    },
    {
      name: "smallClassDetail",
      path: "smallClassDetail",
      component: smallClassDetail
    },
    {
      name: "matchActivity",
      path: "matchActivity",
      component: matchActivity
    },
    {
      name: "matchActivityApply",
      path: "matchActivityApply",
      component: matchActivityApply,
      meta: {
        keepAlive: true
      }
    },
    {
      name: "freeLessonsImg",
      path: "freeLessons",
      component: freeLessons
    },
    {
      name: "matchReward",
      path: "matchReward",
      component: matchReward
    },
    {
      name: "chooseSingleLesson",
      path: "chooseSingleLesson",
      component: chooseSingleLesson
    },
    {
      name: "picassoReward",
      path: "picassoReward",
      component: picassoReward
    },
    {
      name: "privacy",
      path: "privacy",
      component: privacy
    },
    {
      name: "childrenPrivacy",
      path: "childrenPrivacy",
      component: childrenPrivacy
    },
    {
      name: "modalPrivacy",
      path: "modalPrivacy",
      component: modalPrivacy
    },
    {
      name: "modalUpdate",
      path: "modalUpdate",
      component: modalUpdate
    },
    {
      name: "excellentTeacher",
      path: "excellentTeacher",
      component: excellentTeacher
    },
    {
      name: "qualification",
      path: "qualification",
      component: qualification
    },
    {
      name: "makeUpLessons",
      path: "makeUpLessons",
      component: makeUpLessons
    },
    {
      name: "makeUpLessonsCancel",
      path: "makeUpLessonsCancel",
      component: makeUpLessonsCancel
    },
    {
      name: "paintingCategory",
      path: "paintingCategory",
      component: paintingCategory
    },
    {
      name: "paintingCategoryClass",
      path: "paintingCategoryClass",
      component: paintingCategoryClass
    },
    {
      name: "beautifulEducationRevision",
      path: "beautifulEducationRevision",
      component: beautifulEducationRevision
    },
    {
      name: "packageDesc",
      path: "packageDesc",
      component: packageDesc
    },
    {
      name: "aiClassSystem",
      path: "aiClassSystem",
      component: aiClassSystem
    },
    {
      name: "aiClassDetail",
      path: "aiClassDetail",
      component: aiClassDetail
    },
    {
      name: "aiClassRules",
      path: "aiClassRules",
      component: aiClassRules
    },
    {
      name: "aiClassIntroduce",
      path: "aiClassIntroduce",
      component: aiClassIntroduce
    },
    {
      name: "aiClassSingle",
      path: "aiClassSingle",
      component: aiClassSingle
    },
    {
      name: "aiClassTeach",
      path: "aiClassTeach",
      component: aiClassTeach
    },
    {
      name: "courseConsult",
      path: "courseConsult",
      component: courseConsult
    },
    {
      name: "appPrivateAgree",
      path: "appPrivateAgree",
      component: appPrivateAgree
    },
    {
      name: "appUserAgree",
      path: "appUserAgree",
      component: appUserAgree
    },
    {
      name: "appUserRegisterAgree",
      path: "appUserRegisterAgree",
      component: appUserRegisterAgree
    },
    {
      name: "appTouristModel",
      path: "appTouristModel",
      component: appTouristModel
    },
    {
      name: "gameCenter",
      path: "gameCenter",
      component: gameCenter
    },
    {
      name: "myApply",
      path: "myApply",
      component: myApply
    },
    {
      name: "matchActivityNewEnter",
      path: "matchActivityNewEnter",
      component: matchActivityNewEnter
    },
    {
      name: "axleWireSignUp",
      path: "axleWireSignUp",
      component: axleWireSignUp
    },
    {
      name: "axleWireSuccess",
      path: "axleWireSuccess",
      component: axleWireSuccess
    },
    {
      name: "axleWireAgree",
      path: "axleWireAgree",
      component: axleWireAgree
    },
    {
      name: "axleWireAwards",
      path: "axleWireAwards",
      component: axleWireAwards
    },
    {
      name: "appSdkList",
      path: "appSdkList",
      component: appSdkList
    },
    {
      name: "appPersonList",
      path: "appPersonList",
      component: appPersonList
    },
    {
      name: "appVoice",
      path: "appVoice",
      component: appVoice
    },
    {
      name: "appOverPrivate",
      path: "appOverPrivate",
      component: appOverPrivate
    },
    {
      name: "appOverUser",
      path: "appOverUser",
      component: appOverUser
    },
    {
      name: "signPrepare",
      path: "signPrepare",
      component: signPrepare
    },
    {
      name: "signComplete",
      path: "signComplete",
      component: signComplete
    },
    {
      name: "matchActivityAgree",
      path: "matchActivityAgree",
      component: matchActivityAgree
    },
    {
      name: "individuationClass",
      path: "individuationClass",
      component: individuationClass
    },
    {
      name: "searchTeacherForReserve",
      path: "searchTeacherForReserve",
      component: searchTeacherForReserve
    },
    {
      name: "suspendDetail",
      path: "suspendDetail",
      component: suspendDetail
    },
    {
      name: "emptyIntensifyClassAgreement",
      path: "emptyIntensifyClassAgreement",
      component: emptyIntensifyClassAgreement
    },
    {
      name: "yybPayOrder",
      path: "yybPayOrder",
      component: yybPayOrder
    },
    {
      name: "congratulations2024",
      path: "congratulations2024",
      component: congratulations2024
    },
    // 绘画课程
    {
      path: "paintingCourse/subscribe",
      component: paintingCourseSubscribe,
    }
  ]
};
